export const serverErrorMsg =
  "Server is currently offline. Please refresh the page or try again at a later time.";
